import React from 'react';
import { Button } from "@/components/ui/button";
import { PREDEFINED_VARIABLES } from "../constants";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface TemplateVariablesProps {
  selectedCategory: keyof typeof PREDEFINED_VARIABLES;
  setSelectedCategory: (category: keyof typeof PREDEFINED_VARIABLES) => void;
  content: string;
  setContent: (content: string) => void;
  handleInsertVariable: (variable: string) => void;
}

export const TemplateVariables = ({
  selectedCategory,
  setSelectedCategory,
  content,
  setContent,
  handleInsertVariable,
}: TemplateVariablesProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label>Variable Category</Label>
        <Select value={selectedCategory} onValueChange={(value: keyof typeof PREDEFINED_VARIABLES) => setSelectedCategory(value)}>
          <SelectTrigger>
            <SelectValue placeholder="Select category" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="USER">User Variables</SelectItem>
            <SelectItem value="CONTENT">Content Variables</SelectItem>
            <SelectItem value="METRICS">Metric Variables</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div>
        <Label>Available Variables</Label>
        <div className="flex flex-wrap gap-2 mt-2">
          {PREDEFINED_VARIABLES[selectedCategory].map((variable) => (
            <Button
              key={variable}
              type="button"
              variant="outline"
              size="sm"
              onClick={() => handleInsertVariable(variable)}
            >
              {variable}
            </Button>
          ))}
        </div>
      </div>

      <div>
        <Label htmlFor="content">Template Content</Label>
        <div className="mt-1 text-sm text-muted-foreground">
          Click variables above to insert them into your content. Variables will appear as {"{VARIABLE_NAME}"}
        </div>
        <Textarea
          id="content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Enter your template content here. Click variables above to insert them."
          rows={10}
          className="font-mono mt-2"
        />
      </div>
    </div>
  );
};